import React from 'react';
import { Button, Box } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface DialogActionButtonsProps {
  isEncounterCancelled: boolean;
  onDelete: () => void;
  onClose: () => void;
  onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  isEncounterCancelled,
  onDelete,
  onClose,
  onSubmit
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <Button
        onClick={onDelete}
        startIcon={<DeleteIcon />}
        disabled={isEncounterCancelled}
        sx={{
          color: isEncounterCancelled ? '#9e9e9e' : '#dc2626',
          '&:hover': {
            backgroundColor: isEncounterCancelled ? 'transparent' : '#fef2f2',
            color: isEncounterCancelled ? '#9e9e9e' : '#b91c1c'
          },
          '&:disabled': {
            color: '#9e9e9e'
          }
        }}
      >
        {isEncounterCancelled ? 'Disabled (Encounter Cancelled)' : 'Delete Insurance'}
      </Button>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button onClick={onClose} sx={{ color: '#64748b' }}>
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={isEncounterCancelled}
          sx={{
            backgroundColor: isEncounterCancelled ? '#9e9e9e' : '#162346',
            '&:hover': { backgroundColor: isEncounterCancelled ? '#9e9e9e' : '#1a2a52' },
            fontWeight: 600,
            '&:disabled': {
              backgroundColor: '#9e9e9e',
              color: 'rgba(255, 255, 255, 0.6)'
            }
          }}
        >
          {isEncounterCancelled ? 'Read-only Mode' : 'Update Insurance'}
        </Button>
      </Box>
    </Box>
  );
};
